import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

import twitterIcon from 'assets/social_media_icons/twitter.svg';
import facebookIcon from 'assets/social_media_icons/facebook.svg';
import instagramIcon from 'assets/social_media_icons/instagram.svg';
import youtubeIcon from 'assets/social_media_icons/youtube.svg';
import linkedinIcon from 'assets/social_media_icons/linkedin.svg';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 53px;
`;

const StyledConnectWithUsText = styled.p`
  font-size: 16px;
`;

const StyledIcon = styled.img`
  padding-right: 16px;
`;

const SocialMediaLinks = ({ links = {}, showConnectWithUsText = false }) => {
  const { twitter_link, facebook_link, youtube_link, instagram_link, linkedin_link } = links;

  return (
    <StyledContainer>
      {showConnectWithUsText && (
        <StyledConnectWithUsText>
          {getTranslatedString('tenantPortal.connectWithUsOnSocialMedia')}
        </StyledConnectWithUsText>
      )}
      <div>
        {twitter_link && (
          <a href={twitter_link} target="_blank" rel="noopener noreferrer">
            <StyledIcon src={twitterIcon} alt="twitter" />
          </a>
        )}
        {facebook_link && (
          <a href={facebook_link} target="_blank" rel="noopener noreferrer">
            <StyledIcon src={facebookIcon} alt="facebook" />
          </a>
        )}
        {linkedin_link && (
          <a href={linkedin_link} target="_blank" rel="noopener noreferrer">
            <StyledIcon src={linkedinIcon} alt="linkedin" />
          </a>
        )}
        {youtube_link && (
          <a href={youtube_link} target="_blank" rel="noopener noreferrer">
            <StyledIcon src={youtubeIcon} alt="youtube" />
          </a>
        )}
        {instagram_link && (
          <a href={instagram_link} target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="instagram" />
          </a>
        )}
      </div>
    </StyledContainer>
  );
};

export default SocialMediaLinks;
